const localStorageTag = 'opple'// (new Date).getFullYear() + ''+ ((new Date).getMonth()+1) + ''+ (new Date).getDate() + ''+ (new Date).getHours() + ''+ (new Date).getMinutes() + ''+ (new Date).getSeconds() + '';

export function getLocalStorageItem (tag) {
  let localStorageData = localStorage.getItem(localStorageTag)
  localStorageData = JSON.parse(localStorageData)
  if (localStorageData && localStorageData[tag] != null) {
    return localStorageData[tag]
  }
  localStorageData = null
  return null
}

export function setLocalStorageItem (tag, param) {
  if (typeof tag === 'string' && (typeof param === 'string' || typeof param === 'number')) {
    let localStorageData = localStorage.getItem(localStorageTag)
    localStorageData = JSON.parse(localStorageData)
    if (localStorageData == null) {
      localStorageData = {}
    }
    localStorageData[tag] = param
    localStorageData = JSON.stringify(localStorageData)
    localStorage.setItem(localStorageTag, localStorageData)
    localStorageData = null
  }
}

export function removeLocalStorageItem (tag) {
  if (typeof tag === 'string') {
    let localStorageData = localStorage.getItem(localStorageTag)
    localStorageData = JSON.parse(localStorageData)
    if (localStorageData != null) {
      if (localStorageData[tag] != null) {
        delete localStorageData[tag]
        localStorageData = JSON.stringify(localStorageData)
        localStorage.setItem(localStorageTag, localStorageData)
      }
    }
    localStorageData = null
  }
}

export function getStorageCachedObj (storeName, tag) {
  let item = getLocalStorageItem(storeName)
  item = item && JSON.parse(item)
  if (item != null && item[tag] != null) {
    return item[tag]
  } else {
    return null
  }
}

export function setStorageCachedObj (storeName, tag, param) {
  let item = getLocalStorageItem(storeName)
  item = item && JSON.parse(item)
  item = item || {}
  item[tag] = param
  setLocalStorageItem(storeName, JSON.stringify(item))
}

export function delStorageCachedObj (storeName, tag) {
  if (tag === undefined) {
    setLocalStorageItem(storeName, JSON.stringify({}))
  }
  let item = getLocalStorageItem(storeName)
  item = item && JSON.parse(item)
  if (item != null && item[tag] != null) {
    delete item[tag]
    setLocalStorageItem(storeName, JSON.stringify(item))
  }
}
